import { render, staticRenderFns } from "./QueryActiniaI.vue?vue&type=template&id=d0aa814a&"
import script from "./QueryActiniaI.vue?vue&type=script&lang=js&"
export * from "./QueryActiniaI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports